import {GridItemSpanLookuper} from "./services/grid_item_span_lookuper";

export const GridItemDefaultColumnSpan = 1;

export class GridItem {

    constructor(index, prominence, props = {}) {
        this.index = index;
        this.prominence = prominence;
        this.columnCount = null;
        this.columnSpan = GridItemDefaultColumnSpan;
        this.element = props['element'] || null;
    }

    calcColumnSpan() {
        return new GridItemSpanLookuper(this.columnCount, this.prominence).getSpan();
    }

    // Set the column count for the grid this item sits within.
    // Changing the column count means the column span may change.
    setColumnCount(newColumnCount) {
        if (newColumnCount === this.columnCount) return;
        this.columnCount = newColumnCount;
        this.columnSpan = this.calcColumnSpan();
    }

    getColumnSpan() {
        return this.columnSpan || GridItemDefaultColumnSpan;
    }

}